import React from "react";
import { useParams } from "react-router-dom";
import { ProfileCard } from "../../../../components/cards/ProfileCardApplicant";
import ProfileTabs from "../ProfileTabs";
import Publication from "../../../applicant/Onboarding/ResearchNPublication/Publication";
import PublicationSummery from "../../../applicant/Onboarding/ResearchNPublication/PublicationSummery";

export default function ResearchNPublication() {
  const { id } = useParams();
  return (
    <div className="container">
      <div className="row">
        {/* <div className="col-md-3">
          <Sidebar id={id} />
        </div> */}
        <div className="col-md-12">
          <div className="main_contents_div">
            <ProfileCard id={id} />
            <ProfileTabs id={id} />
            <Publication id={id} />
            <PublicationSummery id={id} />
          </div>
        </div>
      </div>
    </div>
  );
}
